import React from 'react'

export const IconDisplay = ({
    className,
    iconName,
    iconSourceMap,
    iconLabel
}: {
    className: string
    iconName: string | undefined
    iconSourceMap: Map<string | undefined, {url: string, label: string}>
    iconLabel: string | undefined
}) => {
    const imageData = iconSourceMap.get(iconName?.toUpperCase()) ?? iconSourceMap.get('default')
    const altIconLabel = iconLabel ?? iconName ?? 'icon image'

    return <img className={className} alt={altIconLabel} src={imageData?.url} title={imageData?.label} data-testid={imageData?.url} />
}
